import React from 'react';
import { CRMObject } from './types';
import CRMMultipleLinks from './CRMMultipleLinks';
import CRMObjectDetails from './CRMObjectDetails';

interface CRMTabContentProps {
  links: CRMObject[];
  isExpanded: boolean;
  toggleExpanded: () => void;
  onDelete?: (crmLink: CRMObject) => void;
}

const CRMTabContent: React.FC<CRMTabContentProps> = ({
  links,
  isExpanded,
  toggleExpanded,
  onDelete,
}) => {
  const hasMultipleLinks = links.length > 1;

  return (
    <div className="flex flex-col gap-0">
      {hasMultipleLinks ? (
        <CRMMultipleLinks
          links={links}
          isExpanded={isExpanded}
          toggleExpanded={toggleExpanded}
          onDelete={onDelete}
        />
      ) : (
        links.map((crmObject, idx) => (
          <CRMObjectDetails key={idx} crmObject={crmObject} onDelete={onDelete} />
        ))
      )}
    </div>
  );
};

export default CRMTabContent;
